import * as firebase from 'firebase/app'
import storage from './storage'

// @firebase/performance@0.2.26 自身实现有BUG
// 在配置未初始化时（依赖domReady和接口配置接口和本地缓存等，见 initializePerf），所有自定义上报被丢弃（见 logTrace settingsService.loggingEnabled/settingsService.logTraceAfterSampling）
// /node_modules/@firebase/performance/dist/index.cjs.js#738 logTrace()

// 提供自定义的初始化完成（可正常上报事件）状态变化 promise
let IS_INITIALIZATION = false
export const performanceInitializationPromise = (function() {

  // 由于其内部未公开API，无法准确判断 performance 初始化完成的时机
  // 根据源码行为（getInitializationPromise）,从 docReady 和 localStorage 写入 两个时机预测是否已初始化完成

  return Promise.resolve()
    .then(() => getDocumentReadyComplete())
    .then(() => new Promise(resolve => setTimeout(resolve, 0)))
    .then(() => checkStorageConfig())
    .then(() => new Promise(resolve => setTimeout(resolve, 1000))) //docReady+storageConfig不能完全保证时序，额外延迟1000ms，极端情况可能延迟后仍未完成
    .then(() => {
      IS_INITIALIZATION = true
    })

  /**
   * 其内部判断 docReady 的原始方法
   * /node_modules/@firebase/performance/dist/index.cjs.js#578
   *
   * Returns a promise which resolves whenever the document readystate is complete or
   * immediately if it is called after page load complete.
   */
  function getDocumentReadyComplete() {
    if(typeof window === 'undefined'){
      return false
    }
    var document = window.document
    return new Promise(function(resolve) {
      if (document && document.readyState !== 'complete') {
        var handler_1 = function() {
          if (document.readyState === 'complete') {
            document.removeEventListener('readystatechange', handler_1)
            resolve()
          }
        }
        document.addEventListener('readystatechange', handler_1)
      } else {
        resolve()
      }
    })
  }

  function checkStorageConfig() {
    if(typeof window === 'undefined'){
      return false
    }
    const CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config'
    const CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire'
    return new Promise(resolve => {
      let intervalHandler
      const check = () => {
        if (storage.get({ key: CONFIG_LOCAL_STORAGE_KEY }) && storage.get({ key: CONFIG_EXPIRY_LOCAL_STORAGE_KEY })) {
          if (intervalHandler) {
            clearInterval(intervalHandler)
            intervalHandler = undefined
          }
          resolve()
        }
      }
      intervalHandler = setInterval(check, 200)
      check()
    })
  }


})()

// hack Track.prototype.record，使其延迟到初始化完成之后再上报
// hack 其它上报方法，增加开发者警告
export function initHack() {
  // 实质需延迟的是 logTrace，但获取不到引用
  const pref = firebase.performance()
  const trace = pref.trace('unused_initialization_track_needle')
  const prototype = trace.__proto__

  // record 方法，fix 成功，不再丢事件
  const ref_record = prototype.record
  prototype.record = function() {
    const ctx = this
    const args = arguments

    // firebase 对于错误格式的自定义跟踪，将直接丢弃
    // 人为校验字段合法性
    const name = this.name
    if (!name || name[0] === ' ' || name[name.length - 1] === ' ' || name[0] === '_' || name.length > 32) {
      console.error(`[firebase] record() name(${name}) 格式错误。正确格式为：自定义属性的名称必须满足以下要求：没有前导或尾随空格、没有前导下划线 (_) 字符，最大长度为 32 个字符`)
    }
    const recordData = args[2]
    if (recordData) {
      if (recordData.attributes) {
        const attrKeys = Object.keys(recordData.attributes)
        if (attrKeys.length > 5) {
          console.error(`[firebase] record() 自定义attributes数量(${attrKeys.length})不能超过5个，本条数据上报将失败`)
        } else {
          attrKeys.every(key => {
            if (!key || key[0] === ' ' || key[key.length - 1] === ' ' || key[0] === '_' || key.length > 32) {
              console.error(`[firebase] record() 自定义attribute名称(${key}) 格式错误。正确格式为：自定义属性的名称必须满足以下要求：没有前导或尾随空格、没有前导下划线 (_) 字符，最大长度为 32 个字符`)
            }
          })
          Object.values(recordData.attributes).forEach(value => {
            if (typeof value !== 'string') {
              console.error(`[firebase] record() 自定义attribute值(${value}) 格式错误。正确格式为：字符串`)
            }
          })
        }
      }
      if (recordData.metrics) {
        const metricKeys = Object.keys(recordData.metrics)
        if (metricKeys.length > 32) {
          console.error(`[firebase] record() 自定义metrics数量(${metricKeys.length})不能超过32个，本条数据上报将失败`)
        } else {
          metricKeys.every(key => {
            if (!key || key[0] === ' ' || key[key.length - 1] === ' ' || key[0] === '_' || key.length > 32) {
              console.error(`[firebase] record() 自定义metric(${key})名称格式错误。正确格式为：自定义指标的名称必须满足以下要求：没有前导或尾随空格、没有前导下划线 (_) 字符，最大长度为 32 个字符`)
            }
          })
          Object.values(recordData.metrics).forEach(value => {
            if (typeof value !== 'number') {
              console.error(`[firebase] record() 自定义metric值(${value}) 格式错误。正确格式为：字符串，${name}:${JSON.stringify(recordData.metrics)}`)
            }
          })
        }
      }
    }

    performanceInitializationPromise.then(() => {
      ref_record.apply(ctx, args)
    }).catch(e=>{
      console.error(`[firebase] ${e}`)
    })
  }

  // stop 方法，无法 hack，增加警告
  const ref_stop = prototype.stop
  prototype.stop = function() {
    if (!IS_INITIALIZATION) {
      console.error('[firebase/performance] 由于其内部实现BUG，此 track.stop() 将丢失自定义跟踪，请改用 track.record()')
    }
    return ref_stop.apply(this, arguments)
  }
}

export function hackLocalStorage() {
  if(typeof window === 'undefined'){
    return false
  }
// Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
// throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
// to avoid the entire page breaking, without having to do a check at each usage of Storage.
  if (typeof localStorage === 'object') {
    try {
      const NAME = 'try_localStorage_70930f27'
      localStorage.setItem(NAME, 1);
      localStorage.removeItem(NAME);
    } catch (e) {
      Storage.prototype._setItem = Storage.prototype.setItem;
      Storage.prototype.setItem = function() {};
      console.warn('[firebase]当前不支持storage')
    }
  }
}

export function hackFetch() {
  if(typeof window === 'undefined'){
    return false
  }

  require("whatwg-fetch")
}
